import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route  , Redirect, useLocation } from 'react-router-dom';
import { TABS, SUBTABS } from './ConstPaths';
import ReviewTabIntro from './ReviewTabIntro';
import ReviewTabCompare from './ReviewTabCompare';
import ReviewTabChoose from './ReviewTabChoose';
import ReviewTabNextsteps from './ReviewTabNextsteps';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.array, //[she, her, hers]
  completedTestDrives: PropTypes.arrayOf(PropTypes.object),
  priority: PropTypes.string,
  platforms: PropTypes.arrayOf(PropTypes.string),
  environments: PropTypes.arrayOf(PropTypes.string),
  bodyPositions: PropTypes.arrayOf(PropTypes.string),
  prospects: PropTypes.arrayOf(PropTypes.object),
  picks: PropTypes.arrayOf(PropTypes.object),
  summaryNotes: PropTypes.string,
  backgroundNotes: PropTypes.string,
  abilitiesNotes: PropTypes.string,
  testdrivesNotes: PropTypes.string,
  decisionsNotes: PropTypes.string,
  recommendationsNotes: PropTypes.string,
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  completedTestDrives: [],
  prospects: [],
  picks: [],
  priority: "",
  platforms: [],
  environments: [],
  bodyPositions: [],
  summaryNotes: "",
  backgroundNotes: "",
  abilitiesNotes: "",
  testdrivesNotes: "",
  decisionsNotes: "",
  recommendationsNotes: "",
};

//when the url matches '/review' this component renders
function ReviewTab(props) {  
  const {
    firstName,
    pronouns,
    providerName,
    completedTestDrives,
    priority,
    platforms,
    environments,
    bodyPositions,
    prospects,
    picks,
    reportData,
    summaryNotes,
    backgroundNotes,
    abilitiesNotes,
    testdrivesNotes,
    decisionsNotes,
    recommendationsNotes,
    updateSession
  } = props;

  const {search} = useLocation();

  console.log("rendering ReviewTab ");

  //render a route for each sub-tab
  //include all props relevant to that sub-tab for initializing and setting
  return(
    <>
    <Switch>
      <Route path={SUBTABS.REVIEW_INTRO}>
        <ReviewTabIntro 
          testDrives={completedTestDrives}
        /> 
      </Route>
      <Route path={[SUBTABS.COMPARE + "/:step", SUBTABS.COMPARE]}>
        <ReviewTabCompare 
          completedTestDrives={completedTestDrives}
        /> 
      </Route>
      <Route path={[SUBTABS.MAKE_CHOICES + "/:step", SUBTABS.MAKE_CHOICES]}>
        <ReviewTabChoose 
          firstName={firstName}
          pronouns={pronouns} 
          priority={priority}
          platforms={platforms}
          environments={environments}
          bodyPositions={bodyPositions}
          prospects={prospects}
          picks={picks}
          updateSession={updateSession}
        /> 
      </Route>
      <Route path={[SUBTABS.NEXT_STEPS + "/:step", SUBTABS.NEXT_STEPS]}>
        <ReviewTabNextsteps 
          firstName={firstName}
          pronouns={pronouns} 
          providerName={providerName}
          picks={picks}
          prospects={prospects}
          summaryNotes={summaryNotes}
          backgroundNotes={backgroundNotes}
          abilitiesNotes={abilitiesNotes}
          testdrivesNotes={testdrivesNotes}
          decisionsNotes={decisionsNotes}
          recommendationsNotes={recommendationsNotes}
          reportData={reportData}
          updateSession={updateSession}
        /> 
      </Route>
      {/* if path is exactly '/review', go to 'review/intro' */}
      <Route exact path={TABS.REVIEW}>
        <Redirect to={SUBTABS.REVIEW_INTRO + search} />
      </Route>
    </Switch>
    </>
  );
}

ReviewTab.propTypes = propTypes;
ReviewTab.defaultProps = defaultProps;

export default ReviewTab;
